import { c as _c } from "react/compiler-runtime";
import { COMPANY_SUBSCRIPTIONS_QUERY_OPTIONS } from "@src/constants/subscription-constants";
import { invalidateActiveMembers } from "@store/active-members/active-members-slice";
import { activeSeatUsageSelector, hasUserRoleConstraintSelector, sceneSeatUsageSelector } from "@store/sdb-company/sdb-company-selector";
import { fetchCompanySubscriptions } from "@store/sdb-company/sdb-company-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";

/**
 * Returns a function that fetches the subscriptions of the workspace again, since the seats in use
 * that the constraints of the plan count (`ACTIVE_SEAT` and `SCENE_SEAT`) only change on the backend.
 * Call it after anything that gives, takes or frees a seat, like removing a member from the workspace.
 *
 * On a plan that limits the active users (the `USER_ROLE` constraint), the active members are marked
 * as outdated as well, since what frees a seat can take away the editor roles that make a member an
 * active user. They are fetched again wherever they are shown, see useFetchActiveMembers.
 *
 * The subscriptions are not fetched when the plan counts no seats, so that workspaces without
 * seats do not fetch them for nothing.
 */
export function useRefreshSeatUsage() {
  const $ = _c(5);
  const dispatch = useAppDispatch();
  const xgSeatUsage = useAppSelector(activeSeatUsageSelector);
  const sceneSeatUsage = useAppSelector(sceneSeatUsageSelector);
  const isUserRolePlan = useAppSelector(hasUserRoleConstraintSelector);
  let t0;
  if ($[0] !== dispatch || $[1] !== isUserRolePlan || $[2] !== sceneSeatUsage || $[3] !== xgSeatUsage) {
    t0 = function refreshSeatUsage() {
      if (isUserRolePlan) {
        dispatch(invalidateActiveMembers());
      }
      if (!xgSeatUsage && !sceneSeatUsage) {
        return;
      }
      dispatch(fetchCompanySubscriptions({
        queryOptions: COMPANY_SUBSCRIPTIONS_QUERY_OPTIONS
      }));
    };
    $[0] = dispatch;
    $[1] = isUserRolePlan;
    $[2] = sceneSeatUsage;
    $[3] = xgSeatUsage;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
}